/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал взаимодействия с внешними партнёрами IoT со стороны партнера
 */

/**
 * Сервис для взаимодействия с внешними партнёрами IoT со стороны партнера
 */
export class IotConnectCallbackServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения пользователя для соединения аккаунтов.
   * Идентификатор пользователя - это subject из токена.
   * Метод доступен для: TokenACF: Scope: sber_iot
   */
  GetCallbackUser = (req?: GetCallbackUserRequestDto, init?: RequestInit): Promise<GetCallbackUserResponseDto> => {
    return fm.request<GetCallbackUserRequestDto, GetCallbackUserResponseDto>(`${this.host}/iot_connect/api/v1/callback/user${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод разъединения аккаунтов.
   * Идентификатор пользователя - это subject из токена.
   * Метод доступен для: TokenACF: Scope: sber_iot
   */
  PostCallbackUnlink = (req?: PostCallbackUnlinkRequestDto, init?: RequestInit): Promise<PostCallbackUnlinkResponseDto> => {
    return fm.request<PostCallbackUnlinkRequestDto, PostCallbackUnlinkResponseDto>(`${this.host}/iot_connect/api/v1/callback/unlink`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения устройств, доступных пользователю.
   * Идентификатор пользователя - это subject из токена.
   * Метод доступен для: TokenACF: Scope: sber_iot
   */
  GetCallbackDevices = (req?: GetCallbackDevicesRequestDto, init?: RequestInit): Promise<GetCallbackDevicesResponseDto> => {
    return fm.request<GetCallbackDevicesRequestDto, GetCallbackDevicesResponseDto>(`${this.host}/iot_connect/api/v1/callback/devices${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Зачем.
   * Метод получения состояния устройства.
   * Идентификатор пользователя - это subject из токена.
   * Метод доступен для: TokenACF: Scope: sber_iot
   */
  PostCallbackQuery = (req?: PostCallbackQueryRequestDto, init?: RequestInit): Promise<PostCallbackQueryResponseDto> => {
    return fm.request<PostCallbackQueryRequestDto, PostCallbackQueryResponseDto>(`${this.host}/iot_connect/api/v1/callback/query`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод запроса внешнего IoT партнёра на изменение состояния устройства.
   * Поддерживается только открытие домофона.
   * Метод доступен для: TokenACF: Scope: sber_iot
   */
  PostCallbackCommand = (req?: PostCallbackCommandRequestDto, init?: RequestInit): Promise<PostCallbackCommandResponseDto> => {
    return fm.request<PostCallbackCommandRequestDto, PostCallbackCommandResponseDto>(`${this.host}/iot_connect/api/v1/callback/command`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Список ключей команд на изменение статуса устройства
 */
export enum DeviceCommandKeyType {
  /**
   * Значение не указано
   */
  KEY_TYPE_UNKNOWN = "KEY_TYPE_UNKNOWN",
  /**
   * Отклонение звонка
   */
  REJECT_CALL = "REJECT_CALL",
  /**
   * Открытие замка
   */
  UNLOCK = "UNLOCK",
}
/**
 * Список ключей команд на изменение статуса устройства
 */
export type DeviceCommandKeyTypeResponseEnum = keyof typeof DeviceCommandKeyType
/**
 * Список ключей команд на изменение статуса устройства
 */
export type DeviceCommandKeyTypeRequestEnum = Exclude<DeviceCommandKeyTypeResponseEnum, "KEY_TYPE_UNKNOWN">;

/**
 * Тип значения команд на изменение статуса устройства
 */
export enum DeviceCommandValueType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Перечисление
   */
  ENUM = "ENUM",
}
/**
 * Тип значения команд на изменение статуса устройства
 */
export type DeviceCommandValueTypeResponseEnum = keyof typeof DeviceCommandValueType
/**
 * Тип значения команд на изменение статуса устройства
 */
export type DeviceCommandValueTypeRequestEnum = Exclude<DeviceCommandValueTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Значения команд на изменение статуса устройства типа перечисление
 */
export enum DeviceCommandValueValueEnumType {
  /**
   * Значение не указано
   */
  VALUE_ENUM_TYPE_UNKNOWN = "VALUE_ENUM_TYPE_UNKNOWN",
  /**
   * Отклонение звонка
   */
  REJECT = "REJECT",
  /**
   * Открытие замка
   */
  UNLOCK = "UNLOCK",
}
/**
 * Значения команд на изменение статуса устройства типа перечисление
 */
export type DeviceCommandValueValueEnumTypeResponseEnum = keyof typeof DeviceCommandValueValueEnumType
/**
 * Значения команд на изменение статуса устройства типа перечисление
 */
export type DeviceCommandValueValueEnumTypeRequestEnum = Exclude<DeviceCommandValueValueEnumTypeResponseEnum, "VALUE_ENUM_TYPE_UNKNOWN">;

/**
 * Список ключей статусов устройства
 */
export enum DeviceStateKeyType {
  /**
   * Значение не указано
   */
  KEY_TYPE_UNKNOWN = "KEY_TYPE_UNKNOWN",
  /**
   * Статус доступности устройства
   */
  ONLINE = "ONLINE",
}
/**
 * Список ключей статусов устройства
 */
export type DeviceStateKeyTypeResponseEnum = keyof typeof DeviceStateKeyType
/**
 * Список ключей статусов устройства
 */
export type DeviceStateKeyTypeRequestEnum = Exclude<DeviceStateKeyTypeResponseEnum, "KEY_TYPE_UNKNOWN">;

/**
 * Тип значения статуса устройства
 */
export enum DeviceStateValueType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Логический тип
   */
  BOOL = "BOOL",
}
/**
 * Тип значения статуса устройства
 */
export type DeviceStateValueTypeResponseEnum = keyof typeof DeviceStateValueType
/**
 * Тип значения статуса устройства
 */
export type DeviceStateValueTypeRequestEnum = Exclude<DeviceStateValueTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Список функций устройства
 */
export enum ModelFeatureType {
  /**
   * Значение не указано
   */
  FEATURE_TYPE_UNKNOWN = "FEATURE_TYPE_UNKNOWN",
  /**
   * Сигнализация о поступившем звонке
   */
  INCOMING_CALL = "INCOMING_CALL",
  /**
   * Сигнализация о доступности устройства
   */
  ONLINE = "ONLINE",
  /**
   * Отклонение звонка
   */
  REJECT_CALL = "REJECT_CALL",
  /**
   * Открытие замка
   */
  UNLOCK = "UNLOCK",
}
/**
 * Список функций устройства
 */
export type ModelFeatureTypeResponseEnum = keyof typeof ModelFeatureType
/**
 * Список функций устройства
 */
export type ModelFeatureTypeRequestEnum = Exclude<ModelFeatureTypeResponseEnum, "FEATURE_TYPE_UNKNOWN">;

/**
 * Объект устройства
 */
export type DeviceRequestDto = {
  /**
   * Идентификатор устройства на платформе Ключ.
   * Конкатенация user_id и device_id плафтормы Ключ
   */
  id?: string
  /**
   * Название устройства на платформе Ключ
   */
  name?: string
  /**
   * Название устройства от производителя
   */
  defaultName?: string
  /**
   * Адрес дома, где установлено устройство
   */
  home?: string
  /**
   * Название или номер подъезда
   */
  room?: string
  /**
   * Тип устройства
   */
  model?: ModelRequestDto | null
  /**
   * HW версия устройства
   */
  hwVersion?: string
  /**
   * SW версия устройства
   */
  swVersion?: string
}
/**
 * Объект устройства
 */
export type DeviceResponseDto = {
  /**
   * Идентификатор устройства на платформе Ключ.
   * Конкатенация user_id и device_id плафтормы Ключ
   */
  id: string
  /**
   * Название устройства на платформе Ключ
   */
  name: string
  /**
   * Название устройства от производителя
   */
  defaultName: string
  /**
   * Адрес дома, где установлено устройство
   */
  home: string
  /**
   * Название или номер подъезда
   */
  room: string
  /**
   * Тип устройства
   */
  model: ModelResponseDto | null
  /**
   * HW версия устройства
   */
  hwVersion: string
  /**
   * SW версия устройства
   */
  swVersion: string
}
/**
 * Команды на изменение статуса устройства
 */
export type DeviceCommandRequestDto = {
  /**
   * Тип команды на изменение статуса устройства
   */
  commandKeyType?: DeviceCommandKeyTypeRequestEnum | "KEY_TYPE_UNKNOWN"
  /**
   * Значение команды на изменение статуса устройства
   */
  value?: DeviceCommandValueRequestDto | null
}
/**
 * Команды на изменение статуса устройства
 */
export type DeviceCommandResponseDto = {
  /**
   * Тип команды на изменение статуса устройства
   */
  commandKeyType: DeviceCommandKeyTypeResponseEnum
  /**
   * Значение команды на изменение статуса устройства
   */
  value: DeviceCommandValueResponseDto | null
}
/**
 * Значение команды на изменение статуса устройства
 */
export type DeviceCommandValueRequestDto = {
  /**
   * Тип значения команды на изменение статуса устройства
   */
  type?: DeviceCommandValueTypeRequestEnum | "TYPE_UNKNOWN"
}
/**
 * value
 */
& fm.OptionalOneOf<{
  /**
   * Значения команды на изменение статуса устройства типа перечисление
   */
  readonly valueEnumType: DeviceCommandValueValueEnumTypeRequestEnum
}>
/**
 * Значение команды на изменение статуса устройства
 */
export type DeviceCommandValueResponseDto = {
  /**
   * Тип значения команды на изменение статуса устройства
   */
  type: DeviceCommandValueTypeResponseEnum
}
/**
 * value
 */
& fm.OneOf<{
  /**
   * Значения команды на изменение статуса устройства типа перечисление
   */
  readonly valueEnumType: DeviceCommandValueValueEnumTypeResponseEnum
}>
/**
 * Массив команд на изменение статуса устройства
 */
export type DeviceCommandArrayRequestDto = {
  /**
   * Команды на изменение статуса устройства
   */
  states?: DeviceCommandRequestDto[]
}
/**
 * Массив команд на изменение статуса устройства
 */
export type DeviceCommandArrayResponseDto = {
  /**
   * Команды на изменение статуса устройства
   */
  states: DeviceCommandResponseDto[]
}
/**
 * Статус устройства
 */
export type DeviceStateRequestDto = {
  /**
   * Тип статуса устройства
   */
  stateKeyType?: DeviceStateKeyTypeRequestEnum | "KEY_TYPE_UNKNOWN"
  /**
   * Значение статуса устройства
   */
  value?: DeviceStateValueRequestDto | null
}
/**
 * Статус устройства
 */
export type DeviceStateResponseDto = {
  /**
   * Тип статуса устройства
   */
  stateKeyType: DeviceStateKeyTypeResponseEnum
  /**
   * Значение статуса устройства
   */
  value: DeviceStateValueResponseDto | null
}
/**
 * Значение статуса устройства
 */
export type DeviceStateValueRequestDto = {
  /**
   * Тип значения статуса устройства
   */
  type?: DeviceStateValueTypeRequestEnum | "TYPE_UNKNOWN"
}
/**
 * value
 */
& fm.OptionalOneOf<{
  /**
   * Значение логического типа
   */
  readonly isValue: boolean
}>
/**
 * Значение статуса устройства
 */
export type DeviceStateValueResponseDto = {
  /**
   * Тип значения статуса устройства
   */
  type: DeviceStateValueTypeResponseEnum
}
/**
 * value
 */
& fm.OneOf<{
  /**
   * Значение логического типа
   */
  readonly isValue: boolean
}>
/**
 * Массив статусов устройства
 */
export type DeviceStateArrayRequestDto = {
  /**
   * Статусы устройства
   */
  states?: DeviceStateRequestDto[]
}
/**
 * Массив статусов устройства
 */
export type DeviceStateArrayResponseDto = {
  /**
   * Статусы устройства
   */
  states: DeviceStateResponseDto[]
}
/**
 * Запрос метода получения устройств, доступных пользователю
 */
export type GetCallbackDevicesRequestDto = {
}
/**
 * Ответ на запрос метода получения устройств, доступных пользователю
 */
export type GetCallbackDevicesResponseDto = {
  /**
   * Домофоны, доступные пользователю
   */
  data: DeviceResponseDto[]
}
/**
 * Запрос метода получения пользователя для соединения аккаунтов
 */
export type GetCallbackUserRequestDto = {
}
/**
 * Ответ на запрос метода получения пользователя для соединения аккаунтов
 */
export type GetCallbackUserResponseDto = {
  /**
   * Идентификатор пользователя
   */
  data: number
}
/**
 * Объект Модель устройства
 */
export type ModelRequestDto = {
  /**
   * Идентификатор модели
   */
  id?: string
  /**
   * Производитель
   */
  manufacturer?: string
  /**
   * Название модели
   */
  model?: string
  /**
   * Версия оборудования
   */
  hwVersion?: string
  /**
   * Версия прошивки
   */
  swVersion?: string
  /**
   * Описание
   */
  description?: string
  /**
   * Категория устройства
   */
  category?: string
  /**
   * Список функций
   */
  featureTypes?: ModelFeatureTypeRequestEnum[]
}
/**
 * Объект Модель устройства
 */
export type ModelResponseDto = {
  /**
   * Идентификатор модели
   */
  id: string
  /**
   * Производитель
   */
  manufacturer: string
  /**
   * Название модели
   */
  model: string
  /**
   * Версия оборудования
   */
  hwVersion: string
  /**
   * Версия прошивки
   */
  swVersion: string
  /**
   * Описание
   */
  description: string
  /**
   * Категория устройства
   */
  category: string
  /**
   * Список функций
   */
  featureTypes: ModelFeatureTypeResponseEnum[]
}
/**
 * Запрос на изменение статуса домофона
 */
export type PostCallbackCommandRequestDto = {
  /**
   * Массив домофонов со статусами
   */
  devices?: {[key:string]:string}
}
/**
 * Ответ на запрос на изменение статуса домофона
 */
export type PostCallbackCommandResponseDto = {
}
/**
 * Запрос статуса домофонов пользователя
 */
export type PostCallbackQueryRequestDto = {
  /**
   * Массив идентификаторов домофонов пользователя
   */
  devices?: string[]
}
/**
 * Ответ на запрос статуса домофонов пользователя
 */
export type PostCallbackQueryResponseDto = {
  /**
   * Массив домофонов со статусами
   */
  data: {[key:string]:string}
}
/**
 * Запрос метода разъединения аккаунтов
 */
export type PostCallbackUnlinkRequestDto = {
}
/**
 * Ответ на запрос метода разъединения аккаунтов
 */
export type PostCallbackUnlinkResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Объект устройства
   */
  "Device": {
    "kind": "class",
    "text": "Объект устройства",
    "fields": {
      /**
       * Идентификатор устройства на платформе Ключ.
       * Конкатенация user_id и device_id плафтормы Ключ
       */
      "id": {
        "type": "string",
        "text": "Идентификатор устройства на платформе Ключ.\nКонкатенация user_id и device_id плафтормы Ключ",
      },
      /**
       * Название устройства на платформе Ключ
       */
      "name": {
        "type": "string",
        "text": "Название устройства на платформе Ключ",
      },
      /**
       * Название устройства от производителя
       */
      "defaultName": {
        "type": "string",
        "text": "Название устройства от производителя",
      },
      /**
       * Адрес дома, где установлено устройство
       */
      "home": {
        "type": "string",
        "text": "Адрес дома, где установлено устройство",
      },
      /**
       * Название или номер подъезда
       */
      "room": {
        "type": "string",
        "text": "Название или номер подъезда",
      },
      /**
       * Тип устройства
       */
      "model": {
        "type": "Model",
        "text": "Тип устройства",
      },
      /**
       * HW версия устройства
       */
      "hwVersion": {
        "type": "string",
        "text": "HW версия устройства",
      },
      /**
       * SW версия устройства
       */
      "swVersion": {
        "type": "string",
        "text": "SW версия устройства",
      },
    },
  },
  /**
   * Команды на изменение статуса устройства
   */
  "DeviceCommand": {
    "kind": "class",
    "text": "Команды на изменение статуса устройства",
    "fields": {
      /**
       * Тип команды на изменение статуса устройства
       */
      "commandKeyType": {
        "type": "DeviceCommand.KeyType",
        "text": "Тип команды на изменение статуса устройства",
      },
      /**
       * Значение команды на изменение статуса устройства
       */
      "value": {
        "type": "DeviceCommand.Value",
        "text": "Значение команды на изменение статуса устройства",
      },
    },
  },
  /**
   * Значение команды на изменение статуса устройства
   */
  "DeviceCommand.Value": {
    "kind": "class",
    "text": "Значение команды на изменение статуса устройства",
    "fields": {
      /**
       * Тип значения команды на изменение статуса устройства
       */
      "type": {
        "type": "DeviceCommand.Value.Type",
        "text": "Тип значения команды на изменение статуса устройства",
      },
      /**
       * Значения команды на изменение статуса устройства типа перечисление
       */
      "valueEnumType": {
        "type": "DeviceCommand.Value.ValueEnumType",
        "text": "Значения команды на изменение статуса устройства типа перечисление",
      },
    },
  },
  /**
   * Массив команд на изменение статуса устройства
   */
  "DeviceCommandArray": {
    "kind": "class",
    "text": "Массив команд на изменение статуса устройства",
    "fields": {
      /**
       * Команды на изменение статуса устройства
       */
      "states": {
        "type": "DeviceCommand",
        "text": "Команды на изменение статуса устройства",
      },
    },
  },
  /**
   * Статус устройства
   */
  "DeviceState": {
    "kind": "class",
    "text": "Статус устройства",
    "fields": {
      /**
       * Тип статуса устройства
       */
      "stateKeyType": {
        "type": "DeviceState.KeyType",
        "text": "Тип статуса устройства",
      },
      /**
       * Значение статуса устройства
       */
      "value": {
        "type": "DeviceState.Value",
        "text": "Значение статуса устройства",
      },
    },
  },
  /**
   * Значение статуса устройства
   */
  "DeviceState.Value": {
    "kind": "class",
    "text": "Значение статуса устройства",
    "fields": {
      /**
       * Тип значения статуса устройства
       */
      "type": {
        "type": "DeviceState.Value.Type",
        "text": "Тип значения статуса устройства",
      },
      /**
       * Значение логического типа
       */
      "isValue": {
        "type": "bool",
        "text": "Значение логического типа",
      },
    },
  },
  /**
   * Массив статусов устройства
   */
  "DeviceStateArray": {
    "kind": "class",
    "text": "Массив статусов устройства",
    "fields": {
      /**
       * Статусы устройства
       */
      "states": {
        "type": "DeviceState",
        "text": "Статусы устройства",
      },
    },
  },
  /**
   * Запрос метода получения устройств, доступных пользователю
   */
  "GetCallbackDevicesRequest": {
    "kind": "class",
    "text": "Запрос метода получения устройств, доступных пользователю",
  },
  /**
   * Ответ на запрос метода получения устройств, доступных пользователю
   */
  "GetCallbackDevicesResponse": {
    "kind": "class",
    "text": "Ответ на запрос метода получения устройств, доступных пользователю",
    "fields": {
      /**
       * Домофоны, доступные пользователю
       */
      "data": {
        "type": "Device",
        "text": "Домофоны, доступные пользователю",
      },
    },
  },
  /**
   * Запрос метода получения пользователя для соединения аккаунтов
   */
  "GetCallbackUserRequest": {
    "kind": "class",
    "text": "Запрос метода получения пользователя для соединения аккаунтов",
  },
  /**
   * Ответ на запрос метода получения пользователя для соединения аккаунтов
   */
  "GetCallbackUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос метода получения пользователя для соединения аккаунтов",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "data": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
    },
  },
  /**
   * Объект Модель устройства
   */
  "Model": {
    "kind": "class",
    "text": "Объект Модель устройства",
    "fields": {
      /**
       * Идентификатор модели
       */
      "id": {
        "type": "string",
        "text": "Идентификатор модели",
      },
      /**
       * Производитель
       */
      "manufacturer": {
        "type": "string",
        "text": "Производитель",
      },
      /**
       * Название модели
       */
      "model": {
        "type": "string",
        "text": "Название модели",
      },
      /**
       * Версия оборудования
       */
      "hwVersion": {
        "type": "string",
        "text": "Версия оборудования",
      },
      /**
       * Версия прошивки
       */
      "swVersion": {
        "type": "string",
        "text": "Версия прошивки",
      },
      /**
       * Описание
       */
      "description": {
        "type": "string",
        "text": "Описание",
      },
      /**
       * Категория устройства
       */
      "category": {
        "type": "string",
        "text": "Категория устройства",
      },
      /**
       * Список функций
       */
      "featureTypes": {
        "type": "Model.FeatureType",
        "text": "Список функций",
      },
    },
  },
  /**
   * Запрос на изменение статуса домофона
   */
  "PostCallbackCommandRequest": {
    "kind": "class",
    "text": "Запрос на изменение статуса домофона",
    "fields": {
      /**
       * Массив домофонов со статусами
       */
      "devices": {
        "type": "{[key:string]:string}",
        "text": "Массив домофонов со статусами",
      },
    },
  },
  /**
   * Ответ на запрос на изменение статуса домофона
   */
  "PostCallbackCommandResponse": {
    "kind": "class",
    "text": "Ответ на запрос на изменение статуса домофона",
  },
  /**
   * Запрос статуса домофонов пользователя
   */
  "PostCallbackQueryRequest": {
    "kind": "class",
    "text": "Запрос статуса домофонов пользователя",
    "fields": {
      /**
       * Массив идентификаторов домофонов пользователя
       */
      "devices": {
        "type": "string",
        "text": "Массив идентификаторов домофонов пользователя",
      },
    },
  },
  /**
   * Ответ на запрос статуса домофонов пользователя
   */
  "PostCallbackQueryResponse": {
    "kind": "class",
    "text": "Ответ на запрос статуса домофонов пользователя",
    "fields": {
      /**
       * Массив домофонов со статусами
       */
      "data": {
        "type": "{[key:string]:string}",
        "text": "Массив домофонов со статусами",
      },
    },
  },
  /**
   * Запрос метода разъединения аккаунтов
   */
  "PostCallbackUnlinkRequest": {
    "kind": "class",
    "text": "Запрос метода разъединения аккаунтов",
  },
  /**
   * Ответ на запрос метода разъединения аккаунтов
   */
  "PostCallbackUnlinkResponse": {
    "kind": "class",
    "text": "Ответ на запрос метода разъединения аккаунтов",
  },
  /**
   * Список ключей команд на изменение статуса устройства
   */
  "DeviceCommand.KeyType": {
    "kind": "enum",
    "text": "Список ключей команд на изменение статуса устройства",
    "values": {
      /**
       * Значение не указано
       */
      "KEY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Отклонение звонка
       */
      "REJECT_CALL": {
        "i": 1,
        "text": "Отклонение звонка",
      },
      /**
       * Открытие замка
       */
      "UNLOCK": {
        "i": 2,
        "text": "Открытие замка",
      },
    },
  },
  /**
   * Тип значения команд на изменение статуса устройства
   */
  "DeviceCommand.Value.Type": {
    "kind": "enum",
    "text": "Тип значения команд на изменение статуса устройства",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Перечисление
       */
      "ENUM": {
        "i": 1,
        "text": "Перечисление",
      },
    },
  },
  /**
   * Значения команд на изменение статуса устройства типа перечисление
   */
  "DeviceCommand.Value.ValueEnumType": {
    "kind": "enum",
    "text": "Значения команд на изменение статуса устройства типа перечисление",
    "values": {
      /**
       * Значение не указано
       */
      "VALUE_ENUM_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Отклонение звонка
       */
      "REJECT": {
        "i": 1,
        "text": "Отклонение звонка",
      },
      /**
       * Открытие замка
       */
      "UNLOCK": {
        "i": 2,
        "text": "Открытие замка",
      },
    },
  },
  /**
   * Список ключей статусов устройства
   */
  "DeviceState.KeyType": {
    "kind": "enum",
    "text": "Список ключей статусов устройства",
    "values": {
      /**
       * Значение не указано
       */
      "KEY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Статус доступности устройства
       */
      "ONLINE": {
        "i": 1,
        "text": "Статус доступности устройства",
      },
    },
  },
  /**
   * Тип значения статуса устройства
   */
  "DeviceState.Value.Type": {
    "kind": "enum",
    "text": "Тип значения статуса устройства",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Логический тип
       */
      "BOOL": {
        "i": 1,
        "text": "Логический тип",
      },
    },
  },
  /**
   * Список функций устройства
   */
  "Model.FeatureType": {
    "kind": "enum",
    "text": "Список функций устройства",
    "values": {
      /**
       * Значение не указано
       */
      "FEATURE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Сигнализация о поступившем звонке
       */
      "INCOMING_CALL": {
        "i": 1,
        "text": "Сигнализация о поступившем звонке",
      },
      /**
       * Сигнализация о доступности устройства
       */
      "ONLINE": {
        "i": 2,
        "text": "Сигнализация о доступности устройства",
      },
      /**
       * Отклонение звонка
       */
      "REJECT_CALL": {
        "i": 3,
        "text": "Отклонение звонка",
      },
      /**
       * Открытие замка
       */
      "UNLOCK": {
        "i": 4,
        "text": "Открытие замка",
      },
    },
  },
}